<template>
  <div>
    <v-toolbar dense flat>
      <v-flex xs8>
        <v-text-field
          v-model="search"
          prepend-icon="search"
          label="Search rider name"
          single-line
          hide-details
          style="padding: 0"
        ></v-text-field>
      </v-flex>
      <v-flex xs4>
        <v-select
          v-model="search_by_status"
          single-line
          hide-details
          style="padding: 0"
          prepend-icon="search"
          label="Search status rider"
          :items="status_list"
        ></v-select>
      </v-flex>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :loading="loading_message"
      :items="filterRiders"
      :pagination.sync="pagination"
      :search="search"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ riders.indexOf(props.item) + 1 }}</td>
        <td class="text-xs-center">{{ props.item.users.users_id }}</td>
        <td class="text-xs-center" v-if="isLoadingDistrict == false">
          <ul>
            <li
              v-for="(district, i) in JSON.parse(
                props.item.user_info.ri_district_id
              )"
              :key="i"
            >
              <span
                v-if="districtList.find((val) => val.district_id == district)"
              >
                {{
                  districtList.find((val) => val.district_id == district)
                    .district_name_th
                }}</span
              >
            </li>
          </ul>
        </td>
        <td class="text-xs-center" v-else>
          <v-progress-circular
            :size="27"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </td>
        <td style="max-width: 200px; overflow: auto">
          {{ props.item.users.users_name }}
        </td>
        <td>{{ props.item.users.users_email }}</td>
        <td class="text-xs-center">{{ props.item.users.users_phone }}</td>
        <td
          v-if="
            props.item.users.user_status == 1 ||
            props.item.users.user_status == 3
          "
          class="text-xs-center"
        >
          <!-- Actived -->
          <div @click="openDialog(riders.indexOf(props.item))">
            <v-switch
              color="#fddf00"
              readonly
              style="margin-top: 25px"
              :input-value="riders_status[riders.indexOf(props.item)]"
            ></v-switch>
          </div>
        </td>
        <td
          v-else-if="props.item.users.user_status == 2"
          class="text-xs-center"
        >
          <v-switch
            v-model="riders_status[riders.indexOf(props.item)]"
            disabled
          ></v-switch>
        </td>
        <!-- <td
          v-else-if="props.item.users.user_status == 3"
          class="text-xs-center"
        >
          <v-switch
            v-model="isActive[riders.indexOf(props.item)]"
            color="#fddf00"
            style="margin-top: 25px"
          ></v-switch>
          Inactive
        </td> -->
        <td v-else class="text-xs-center">
          <span
            class="px-2 py-1 white--text"
            style="background-color: red; border-radius: 10px"
          >
            Delete
          </span>
        </td>
        <td class="text-xs-center" v-if="hideAction == false">
          <v-tooltip top>
            <v-btn
              icon
              slot="activator"
              :to="
                '/weserve_admin_login/control/' +
                $store.state.backOffice.province +
                '/rider/rider/' +
                props.item.users.id
              "
            >
              <v-icon small>remove_red_eye</v-icon>
            </v-btn>
            <span>View</span>
          </v-tooltip>
          <v-tooltip top v-if="!isEditRiderList">
            <v-btn
              icon
              slot="activator"
              :to="
                '/weserve_admin_login/control/' +
                $store.state.backOffice.province +
                '/rider/rideredit/' +
                props.item.users.id
              "
            >
              <v-icon small>edit</v-icon>
            </v-btn>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip top v-if="!isEditRiderList">
            <v-btn
              icon
              slot="activator"
              @click="deleteRider(props.item.users.id)"
              :loading="deleting_rider.includes(props.item.users.id)"
              :disabled="deleting_rider.includes(props.item.users.id)"
            >
              <v-icon small>delete</v-icon>
            </v-btn>
            <span>Delete</span>
          </v-tooltip>
        </td>
      </template>

      <template slot="no-data">
        <div class="text-xs-center" v-if="loading_message == false">
          No data available
        </div>
        <div class="text-xs-center" v-else>
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular
          >Loading data ...
        </div>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialog"
      max-width="350"
      origin
      persistent
      content-class="elevation-0"
    >
      <v-card>
        <v-card-title class="headline">เปลี่ยนสถานะ</v-card-title>

        <v-card-text> คุณต้องการเปลี่ยนสถานะไรเดอร์ใช่หรือไม่ </v-card-text>

        <v-card-actions style="margin-top: 15px">
          <v-spacer></v-spacer>

          <v-btn flat="flat" @click="dialog = false"> ไม่ </v-btn>
          <v-btn color="primary" flat="flat" @click="updateRiderStatus()">
            ใช่
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogInOrder"
      max-width="350"
      origin
      persistent
      content-class="elevation-0"
    >
      <v-card>
        <v-card-title class="headline">แจ้งเตือน</v-card-title>
        <v-card-text>
          ไม่สามารถเปลี่ยนสถานะได้ เพราะไรเดอร์มีออเดอร์ที่ทำอยู่
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary" flat="flat" @click="closeDialogInOrder()">
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <div class="text-xs-center py-2">
      <v-pagination circle v-model="pagination.page" :length="pages"></v-pagination>
    </div>-->
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  props: {
    riders: {},
    hideAction: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      isActive: [],
      changeStatusId: 99999,
      dialogInOrder: false,
      dialog: false,
      isLoadingDistrict: false,
      districtList: [],
      status_list: [
        {
          text: "All",
          value: 99,
        },
        {
          text: "Actived",
          value: 1,
        },
        {
          text: "Pending",
          value: 2,
        },
        {
          text: "Inactive",
          value: 3,
        },
      ],
      search_by_status: 99,
      search: "",
      deleting_rider: [],
      loading_message: false,
      pagination: {
        rowsPerPage: 10,
      },
    };
  },
  computed: {
    ...mapState({
      riders_inhouse: (state) => state.fetchRiderListBack.riders_inhouse,
      riders_status: (state) => state.fetchRiderListBack.riders_status,
      permission: (state) => state.permission,
      provinceData: (state) => state.fetchProvinceBack.provinceData,
    }),
    isEditRiderList() {
      if (!this.permission.rider.rider_list.rider_user) {
        return true;
      }
      return this.permission.rider.rider_list.rider_user == 1 ? true : false;
    },
    pages() {
      this.pagination.totalItems = this.riders_inhouse.length;
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
    filterRiders() {
      if (this.search_by_status == 99) {
        return this.riders;
      } else {
        return this.riders.filter((val) => {
          return val.users.user_status == this.search_by_status;
        });
      }
    },
    headers() {
      let headerList = [
        { text: "No.", align: "center", sortable: false, value: "name" },
        {
          text: "Username",
          value: "calories",
          align: "center",
          sortable: false,
        },
        { text: "Area", value: "fat", align: "center", sortable: false },
        {
          text: "Name",
          value: "users.users_name",
          align: "center",
          sortable: false,
        },
        { text: "Email", value: "protein", align: "center", sortable: false },
        { text: "Tel.", value: "iron", align: "center", sortable: false },
        {
          text: "Status",
          value: "users.user_status",
          align: "center",
          sortable: false,
        },
      ];

      if (this.hideAction == false) {
        headerList.push({
          text: "Actions",
          value: "action",
          align: "center",
          sortable: false,
        });
      }
      return headerList;
    },
  },
  async created() {
    this.fetchRiderList();
    this.fetchDistrictList();
  },
  watch: {},
  methods: {
    ...mapActions({
      getDistrictCore: "fetchProvinceBack/getDistrictCore",
    }),
    async fetchDistrictList() {
      let province = this.$route.params.province;
      this.isLoadingDistrict = true;
      let provinceItem = this.provinceData.find(
        (val) =>
          val.province_name_en.toLowerCase().replace(/ /g, "") == province
      );
      this.districtList = await this.getDistrictCore(provinceItem.province_id);
      this.isLoadingDistrict = false;
    },
    async fetchRiderList() {
      this.loading_message = true;
      await this.$store.dispatch(
        "fetchRiderListBack/getRiderList",
        this.$route.params.province
      );
      this.loading_message = false;
    },
    deleteRider(rider_id) {
      confirm("Do you want to delete this rider account ? ") &&
        this.deleteFromServer(rider_id);
    },
    async deleteFromServer(rider_id) {
      this.deleting_rider.push(rider_id);
      await this.$store.dispatch("fetchRiderListBack/deleteRider", rider_id);
      let index = this.deleting_rider.findIndex((val) => val == rider_id);
      this.deleting_rider.splice(index, 1);
    },
    openDialog(id) {
      this.dialog = true;
      this.changeStatusId = id;
    },
    closeDialogInOrder() {
      this.dialogInOrder = false;
      this.dialog = false;
    },
    async updateRiderStatus() {
      let province = this.$route.params.province;
      let sendData = {
        province: province,
        rider_id: this.changeStatusId,
        data: {
          users_status_check: 0,
          user_id: this.riders[this.changeStatusId].users.users_id,
          user_status: this.riders_status[this.changeStatusId] == true ? 3 : 1,
        },
      };
      let res = await this.$store.dispatch(
        "fetchRiderListBack/updateRiderStatus",
        sendData
      );

      if (res == false) {
        this.dialogInOrder = true;
      } else {
        this.dialog = false;
      }
    },
  },
};
</script>

<style scoped></style>
